import { userIsNotAuthenticatedRedir } from 'components/auth/hoc';
import { compose } from 'recompose';
import React from 'react';
import { getCurrentTenantBusinessConfig } from 'tenant/business/signUp';
import LandingRegisterForm from '../components/forms/LandingRegisterForm';
import styled from 'styled-components';
import {
  expandHeightAndWidth,
  Flex,
  gridSizes,
  media,
  weights,
} from 'utils/style';

const LandingRegisterComponent = ({ className }) => {
  const businessConfig = getCurrentTenantBusinessConfig();

  return (
    <div className={`${className} public-page`}>
      <section className="main" role="main">
        <LandingRegisterForm props={businessConfig.signUp} />
      </section>
    </div>
  );
};

const enhance = compose(userIsNotAuthenticatedRedir);
const StyledLandingRegister = styled(LandingRegisterComponent)`
  ${Flex.column}
  ${expandHeightAndWidth()}
  color: var(--grey700);
  background-color: transparent !important;

  ${media.lessThan('extraSmall')`
    font-size: 14px;
  `};

  .main {
  overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 32px;
    ${media.lessThan('small')`
      justify-content: start;
      margin-top: 180px;
      margin-bottom: 80px;
    `};  

    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};
      margin-top: 140px;
      margin-bottom: 90px;
    `};
  }

svg {
    margin: 0 0 64px;
    fill: var(--white);

    ${media.lessThan('extraSmall')`
      fill: var(--primary500);
      width: 94px;
      height: 26px;
      align-self: flex-start;
    `};
  }
  .info {
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:first-of-type {
      margin: 64px 0 0;
    }
    a {
      color: var(--white);
      font-weight: ${weights('bold')};
      text-decoration: underline;
      font-size: ${gridSizes('M')};
      &:hover {
        filter: invert(8%);
      }
    }

    ${media.lessThan('extraSmall')`
      margin: ${gridSizes('L')} 0 0;
      &:first-of-type {
        margin: 32px 0 0;
      }
      a {
        color: var(--primary500);
        display: block;
        text-align: center;
        font-size: 14px;
        text-decoration: none;
        font-weight: ${weights('regular')};
        &:hover {
          text-decoration: underline;
        }
      }
    `};
  }
`;

const LandingRegister = enhance(StyledLandingRegister);
export { LandingRegister };
